export const demandsQueryKeys = {
  all: () => ['/demands'] as const,
  lists: () => [...demandsQueryKeys.all(), 'list'] as const,
  list: (params: Record<string, unknown>) =>
    [...demandsQueryKeys.lists(), JSON.stringify(params)] as const,
  detail: (id: number) => ['/demands', id] as const,
};
